export const SET_CURRENT_STEP = "SET_CURRENT_STEP";
export const SAVE_WARE = 'SAVE_WARE';
export const GET_WARE_DETAIL = 'GET_WARE_DETAIL';
export const SET_WARE_DETAIL = 'SET_WARE_DETAIL';
export const CHANGE_WARE_STATE = 'CHANGE_WARE_STATE';
export const SET_SELECTED = 'SET_SELECTED';
export const SET_COMBINATION = 'SET_COMBINATION';


// WEBPACK FOOTER //
// ./src/store/create-ware/type.js